var $12084690a0b76ac4$exports = {};
$12084690a0b76ac4$exports = {
    "alert": `Alert\u{103}`,
    "dismiss": `Revocare`
};


export {$12084690a0b76ac4$exports as default};
//# sourceMappingURL=ro-RO.module.js.map
